/* eslint-disable react/destructuring-assignment */
import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import React, { useContext } from 'react'

import TicketVariantContext, { TicketVariant } from '../../lib/TicketVariantContext'
import BenefitListContext from './BenefitListContext'

const useStyles = makeStyles(theme => ({
  dark: {},
  promoted: {
    '&$dark': {
      backgroundColor: theme.palette.secondary.dark,
    },
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
  },
  root: {
    padding: theme.spacing(1, 3),
  },
  roundedBottom: {
    borderBottomLeftRadius: theme.shape.borderRadius,
    borderBottomRightRadius: theme.shape.borderRadius,
  },
  roundedTop: {
    borderTopLeftRadius: theme.shape.borderRadius,
    borderTopRightRadius: theme.shape.borderRadius,
  },
  soldOut: {
    '&$dark': {
      backgroundColor: theme.palette.grey[300],
    },
    backgroundColor: theme.palette.grey[200],
    color: theme.palette.grey[500],
  },
  standard: {
    '&$dark': {
      backgroundColor: theme.palette.grey[200],
    },
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
  },
}))

export type BenefitItemProps = {
  children?: React.ReactNode
  className?: string
  dark?: boolean
  roundedBottom?: boolean
  roundedTop?: boolean
}

const BenefitItem = ({
  children,
  className,
  dark,
  roundedTop,
  roundedBottom,
}: BenefitItemProps) => {
  const classes = useStyles()
  const { variant } = useContext(TicketVariantContext)
  const context = useContext(BenefitListContext)

  return (
    <Box
      className={clsx(
        classes.root,
        {
          [classes.promoted]: variant === TicketVariant.Promoted,
          [classes.soldOut]: variant === TicketVariant.SoldOut,
          [classes.standard]: variant === TicketVariant.Standard,
          [classes.dark]: dark || context.dark,
          [classes.roundedTop]: roundedTop || context.roundedTop,
          [classes.roundedBottom]: roundedBottom || context.roundedBottom,
        },
        className
      )}
    >
      {children}
    </Box>
  )
}

export default BenefitItem
